import { Layers } from 'lucide-react';

/**
 * Summarize Pass 2 artifact → timeline screen mapping from timeline.artifact_plan.
 */
export function TimelineArtifactPlanPanel({ timeline }) {
  const plan = timeline?.artifact_plan || [];
  if (!plan.length) {
    return (
      <p className="text-xs text-slate-500 rounded-sm border border-slate-700/60 bg-slate-900/50 px-3 py-2">
        No artifact plan on timeline — regenerate timeline after Pass 3 to map Pass 2 artifacts to screens.
      </p>
    );
  }

  const mapped = plan.filter((e) => e.scene_index != null).length;

  return (
    <div className="rounded-sm border border-violet-500/25 bg-violet-950/20 px-3 py-3 space-y-2">
      <p className="text-xs font-semibold text-violet-200 flex items-center gap-1.5">
        <Layers className="w-3.5 h-3.5 shrink-0" />
        Pass 2 artifact screen plan — {mapped}/{plan.length} mapped
      </p>
      <ul className="space-y-1 max-h-48 overflow-y-auto">
        {plan.map((entry) => (
          <li
            key={`${entry.dfs_path}-${entry.artifact_type}`}
            className="text-[11px] text-slate-300 flex flex-wrap gap-x-2 gap-y-0.5"
          >
            <span className="font-mono text-violet-300/90 shrink-0">
              scene {entry.scene_index != null ? entry.scene_index + 1 : '—'}
            </span>
            <span className="text-slate-400">{entry.artifact_type}</span>
            <span className="text-slate-200 truncate">{entry.heading}</span>
            {entry.layer ? (
              <span className="text-slate-600 text-[10px]">{entry.layer}</span>
            ) : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
